import { SelectV2 } from "@/modules/common/components";

import { FilterFieldRendererProps } from "../types";

const SelectMultipleFilterField = ({ field, value, onChange }: FilterFieldRendererProps<unknown[]>) => (
  <SelectV2
    mode="multiple"
    align="start"
    placeholder={field.label}
    options={field.options ?? []}
    value={(value ?? []).map(String)}
    onChange={(next) => {
      if (!next?.length) {
        onChange(undefined);
        return;
      }
      const parsed = field.schema.safeParse(next);
      onChange(parsed.success ? parsed.data : undefined);
    }}
  />
);

export default SelectMultipleFilterField;
